// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uMei","newExpiryDate":"styles_newExpiryDate__85yc6","footer":"styles_footer__OFade"};